import { combineReducers, configureStore } from '@reduxjs/toolkit'
// import { load /* , save */ } from 'redux-localstorage-simple'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import application from './application/reducer'
import chart from './chart/reducer'
// import swap from './swap/reducer'
// import transactions from './transactions/reducer'
// import bridgeTransactions from './bridgeTransactions/reducer'
import { updateVersion } from './global/actions'
// import burn from './burn/reducer'
// import create from './create/reducer'
// import limitOrder from './limit-order/reducer'
import lists from './lists/reducer'
// import mint from './mint/reducer'
import multicall from './multicall/reducer'
import user from './user/reducer'
// import zap from './zap/reducer'

// const PERSISTED_KEYS: string[] = [/* 'user', 'transactions',*/ 'lists', /* 'bridgeTransactions', 'swap'*/]

const reducer = combineReducers({
  application,
  user,
  chart,
  // transactions,
  // bridgeTransactions,
  // swap,
  // mint,
  // burn,
  multicall,
  lists,
  // zap,
  // limitOrder,
  // create,
})

const persistConfig = {
  key: 'root',
  storage,
  // blacklist: ['chart', 'lists', 'multicall', 'user', 'application'], // lists will not be persisted
}
const store = configureStore({
  // reducer,
  reducer: persistReducer(persistConfig, reducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      immutableCheck: true,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV === 'development',
  // preloadedState: load({ states: PERSISTED_KEYS, disableWarnings: true }),
})
export const persistor = persistStore(store)
store.dispatch(updateVersion())

export default store
